import { jsx, jsxs } from "react/jsx-runtime";
import { useTranslation } from "react-i18next";
import { Col, Row } from "@perxis-auto/ui-kit/lib/components/Grid";
import { Typography } from "@perxis-auto/ui-kit/lib/components/Typography";
import { APP } from "../../config/app.js";
import "../../config/env.js";
import "../../config/events.js";
import "../../lib/store/createAppApi.js";
import "../../lib/store/createAppAsyncThunk.js";
import "../../lib/store/createAppSelector.js";
import "../../lib/store/createAppSlice.js";
import "react";
import "redux";
import "../../lib/store/hooks/useAppDispatch.js";
import { useAppSelector } from "../../lib/store/hooks/useAppSelector.js";
import "../../lib/store/hooks/useAppStore.js";
import "../../store/config/middleware/index.js";
import { selectBenefits } from "../../store/config/model/selectors/selectBenefits.js";
import "../../store/config/model/selectors/selectBooking.js";
import "../../store/config/model/selectors/selectCredit.js";
import "../../store/config/model/selectors/selectFilterGrid.js";
import "../../store/config/model/selectors/selectFilterGridItems.js";
import "../../store/config/model/selectors/selectFilters.js";
import "../../store/config/model/selectors/selectGeo.js";
import "../../store/config/model/selectors/selectGeolocator.js";
import "../../store/config/model/selectors/selectLocationCollectionIds.js";
import "../../store/config/model/selectors/selectMaps.js";
import "../../store/config/model/selectors/selectModels.js";
import "../../store/config/model/selectors/selectSort.js";
import "../../store/config/model/selectors/selectTags.js";
import "../../store/config/model/selectors/selectTradeIn.js";
import "../../store/config/model/slice.js";
import styles from "./BenefitsTooltip.module.scss.js";
function BenefitsTooltipContent({ benefits, carPrice }) {
  const { t } = useTranslation(APP.name);
  const benefitsConfig = useAppSelector(selectBenefits);
  const { showAmount } = benefitsConfig;
  const getPriceWithDiscount = (discount) => {
    const price = typeof carPrice === "string" ? Number(carPrice) : carPrice;
    if (!price) {
      return 0;
    }
    return price - discount;
  };
  if (!benefits || benefits.length === 0) {
    return null;
  }
  return /* @__PURE__ */ jsx(Col, { span: 24, className: styles.benefitsTooltipContent, children: /* @__PURE__ */ jsxs(Row, { gutter: [0, 10], children: [
    /* @__PURE__ */ jsx(Col, { span: 24, children: /* @__PURE__ */ jsxs(Row, { children: [
      /* @__PURE__ */ jsx(Col, { span: showAmount ? 12 : 18, className: styles["benefitsTooltipContent__table--align-start"], children: /* @__PURE__ */ jsx(Typography.Text, { level: "h5", color: "dark-light", className: styles.benefitsTooltipContent__tableTitle, children: benefitsConfig.tooltipBenefitColumn }) }),
      showAmount && /* @__PURE__ */ jsx(Col, { span: 6, className: styles["benefitsTooltipContent__table--align-end"], children: /* @__PURE__ */ jsx(Typography.Text, { level: "h5", color: "dark-light", className: styles.benefitsTooltipContent__tableTitle, children: benefitsConfig.tooltipDiscountColumn }) }),
      /* @__PURE__ */ jsx(Col, { span: 6, className: styles["benefitsTooltipContent__table--align-end"], children: /* @__PURE__ */ jsx(Typography.Text, { level: "h5", color: "dark-light", className: styles.benefitsTooltipContent__tableTitle, children: benefitsConfig.tooltipPriceColumn }) })
    ] }) }),
    benefits.map((benefit) => /* @__PURE__ */ jsx(Col, { span: 24, children: /* @__PURE__ */ jsxs(Row, { children: [
      /* @__PURE__ */ jsx(Col, { span: showAmount ? 12 : 18, className: styles["benefitsTooltipContent__table--align-start"], children: /* @__PURE__ */ jsx(Typography.Text, { level: "super-small", color: "dark", className: styles.benefitsTooltipContent__tableLabel, children: benefit.displayName }) }),
      showAmount && /* @__PURE__ */ jsx(Col, { span: 6, className: styles["benefitsTooltipContent__table--align-end"], children: /* @__PURE__ */ jsx(
        Typography.Text,
        {
          level: "super-small",
          color: "darkest",
          className: styles.benefitsTooltipContent__tablePrice,
          children: t("format.currency", {
            value: benefit.value,
            style: "decimal"
          })
        }
      ) }),
      /* @__PURE__ */ jsx(Col, { span: 6, className: styles["benefitsTooltipContent__table--align-end"], children: /* @__PURE__ */ jsx(
        Typography.Text,
        {
          level: "super-small",
          color: "darkest",
          className: styles.benefitsTooltipContent__tablePrice,
          children: t("format.currency", {
            value: getPriceWithDiscount(benefit.value),
            style: "decimal"
          })
        }
      ) })
    ] }) }, benefit.id))
  ] }) });
}
export {
  BenefitsTooltipContent
};
